import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { observable, configure } from "mobx";
import { BrowserRouter } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import App from './App';
import OfflineExpenses from './pages/offline-expenses';
import DataStore from './utils/data-store';
require(`./scss/${process.env.REACT_APP_ENV.replace(/\\.*$/, '')}.scss`);

configure({
    enforceActions: "never",
});

if (process.env.REACT_APP_ENABLE_OFFLINE_MODE === 'true' && 'serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        try {
            await navigator.serviceWorker.register('/service-worker.js');
        } catch (err) {
            //console.error('Service Worker registration failed:', err);
        }
    });
}

const isOpenInOfflineMode = !navigator.onLine;

let lang = navigator.language || navigator.userLanguage;
if (lang) {
    lang = lang.substring(0, 2);
}

const savedData = DataStore.createInitialDataStore(lang);
const data = observable(savedData);

const AppWrapper = () => {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    useEffect(() => {
        data.isMobile = isMobile;
    }, [isMobile]);

    return (
        <BrowserRouter>
            { isOpenInOfflineMode
                ? <OfflineExpenses data={data} />
                : <App data={data} />
            } 
        </BrowserRouter>
    );
};

ReactDOM.render(
    <React.StrictMode>
        <AppWrapper />
    </React.StrictMode>,
    document.getElementById('root')
);
